import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BackToStreamButton from '../../../Duperbrowse/BackToStreamButton';
import Details from '../../../DeviationViews/Details';
import Sidebar from '../../../Sidebar';
import ActionBar from '../../../ActionBar';
import ArtStage from '../../../ArtStage';
import LoadingIndicator from '../../../LoadingIndicator';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { isExtendedDeviationFullyLoaded } from '../../redux/helpers';
import Comments from '../Comments';
import CentralColumn from '../CentralColumn';
import PanelPopup from '../PanelPopup';
import s from './SimplePage.scss';
export var SimplePage = function (_a) {
    var _b = _a.withSidebar, withSidebar = _b === void 0 ? true : _b, deviation = _a.deviation;
    var isMobile = useContext(MobileContext);
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var needsSubscription = useSubscriptionTier(deviation).needsSubscription;
    return (React.createElement("div", { className: classnames(s['root'], withSidebar && !isMobile && s['sidebar']) },
        React.createElement("div", { className: classnames(s['left-column'], s['stage']) },
            React.createElement(ArtStage, { deviation: deviation }),
            React.createElement(BackToStreamButton, null),
            React.createElement(ActionBar, { deviation: deviation }),
            React.createElement(PanelPopup, { deviation: deviation, actionBarType: "primary", className: s['large-popover-uplifted'] }),
            React.createElement(CentralColumn, null,
                React.createElement(Details, { deviation: deviation }))),
        withSidebar && !isMobile && (React.createElement(Sidebar, { deviation: deviation, className: s['right-column'] })),
        React.createElement("div", { className: classnames(s['left-column'], s['meta']) },
            React.createElement(CentralColumn, { supportSidebar: withSidebar },
                !needsSubscription && isExtendedLoaded && (React.createElement(Comments, { deviation: deviation, className: s['comments'] })),
                !needsSubscription && !isExtendedLoaded && (React.createElement(LoadingIndicator, { className: s['lloader'], view: "llama" })))),
        withSidebar && isMobile && (React.createElement(Sidebar, { deviation: deviation, className: s['right-column'] })),
        withSidebar && React.createElement("div", { className: s['clear'] })));
};
SimplePage.displayName = 'SimplePage';
export default SimplePage;
//# sourceMappingURL=SimplePage.js.map